// extracted by mini-css-extract-plugin
module.exports = {"pagination":"styles_pagination__3MBwg","selected":"styles_selected__2V8-F","label":"styles_label__1VeQv"};